import { ReactNode } from 'react'
import { useSelector } from 'react-redux'

import { RootState } from 'providers/redux'
import { abilityBuilder } from './abilityBuilder'
import { AbilityContext } from './abilityContext'
import { Ability } from './types/ability'

export const AbilityProvider = ({ children }: { children: ReactNode }): JSX.Element => {
  const { user } = useSelector((state: RootState) => state.user)

  const ability: Ability = abilityBuilder(user)

  return <AbilityContext.Provider value={ability}>{children}</AbilityContext.Provider>
}
